import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, getIdTokenResult, signOut, onAuthStateChanged } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import CircleLoading from '../common/CircleLoading/CircleLoading';
import { removeUser } from '../../store/slices/userSlice';
import { disconnectSocket } from '../../utils/socketManager';
interface ProtectedRouteProps {
  element: React.ReactNode;
}
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        dispatch(removeUser());
        navigate('/signin');
        return;
      }
      try {
        const tokenResult = await getIdTokenResult(user);
        const expiresAt = new Date(tokenResult.expirationTime).getTime();
        const now = Date.now();
        if (now >= expiresAt) {
          await signOut(auth);
          disconnectSocket();
          dispatch(removeUser());
          navigate('/signin');
        } else {
          setLoading(false);
        }
      } catch (err) {
        console.error('Token validation error:', err);
        await signOut(auth);
        disconnectSocket();
        dispatch(removeUser());
        navigate('/signin');
      }
    });
    return () => unsubscribe();
  }, []);
  if (loading) {
    return <CircleLoading text="Loading..." subText="Authenticating..." />;
  }
  return <>{element}</>;
};
export default ProtectedRoute;
